import { formConnectFactory } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/shared/Form.connect';
import { connect } from 'react-redux';
import { limitOrderInputFormSelectors } from 'state/secondaryMarket/limit-order/form/input/inputForm.selectors';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';

const { mapStateToProps, mapDispatchToProps } = formConnectFactory(
  limitOrderReferentialSelectors,
  limitOrderSelectors,
  limitOrderInputFormSelectors,
  limitOrderThunks,
);
export const connectLimitOrderForm = connect(mapStateToProps, mapDispatchToProps);
